import { connect } from 'react-redux';
import ForkGroupFilterDetails from '../components/ForkGroupFilterDetails';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';


export default connect(
  null,
  defaultMapDispatchToProps
)(ForkGroupFilterDetails);